module.exports = __webpack_public_path__ + "static/Self-Health-Coach-Section-74b0d970185b557d2a6269f485d61951.png";